import React, { useState } from 'react'
//import './FilterForm.css'
import {localestr,validate_ex_mark} from '../utils.js'
import Edit from './Edit'

function LongTextForm({capt,value,setModal,action,ex_mark=true}){
    const [val,setVal]=useState(value)

    let pos1 = 0, pos2 = 0, pos3 = 0, pos4 = 0;

    function dragMouseDown(e) {
      e = e || window.event;
      // get the mouse cursor position at startup:
      pos3 = e.clientX;
      pos4 = e.clientY;
      document.onmouseup = closeDragElement;
      // call a function whenever the cursor moves:
      document.onmousemove = elementDrag;
    }
  
    function elementDrag(e) {
      const elmnt=document.getElementById('modalWnd')
      e = e || window.event;
      // calculate the new cursor position:
      pos1 = pos3 - e.clientX;
      pos2 = pos4 - e.clientY;
      pos3 = e.clientX;
      pos4 = e.clientY;
      // set the element's new position:
      if (pos2!==0) elmnt.style.top = (elmnt.offsetTop - pos2) + "px";
      if (pos1!==0) elmnt.style.left = (elmnt.offsetLeft - pos1) + "px";
    }
  
    function closeDragElement() {
      /* stop moving when mouse button is released:*/
      document.onmouseup = null;
      document.onmousemove = null;
    }

    function keyClick(e){
      //console.log(e)
      if(e.key==='Enter' && e.shiftKey) {setModal('');action(val)}
      else if(e.key==='Escape') {setModal('');action(null)}
    }

    function set_Val(d){
      if(ex_mark) setVal(validate_ex_mark(d))
      else setVal(d)
    }

    return(
        <div className='modal_f'><div id='modalWnd' className='window'>
            <div onMouseDown={dragMouseDown} style={{flexDirection:'row',display:'flex',justifyContent:'flex-start'}}><div className='caption'>{capt}</div><div className='closebtn' onClick={()=>{setModal('')}}/></div>
            <div className='content'>
            <div onKeyUp={keyClick} style={{margin:'10px 0 0 0',display:'flex',justifyContent:'center'}}>
            <Edit Value={val} typeVal={'longtext'} setVal={set_Val} style={{display:'inline-flex',width:'100%',boxSizing:'border-box',height:'200px',flexBasis:'150px',flexGrow:'150',fontSize:'inherit',fontFamily:'inherit'}} id={'id'+Math.random()} isActive={true} />
            </div>
            <div style={{margin:'10px 0 0 0',display:'flex',justifyContent:'center'}}>
            <div style={{width:'80px', display:'inline-block',verticalAlign:'bottom'}} className={'key_btn'} onClick={()=>{setModal('');action(val)}}><div style={{height:'30px',lineHeight:'30px',display:'block'}}>OK</div></div>
            <div style={{width:'80px', display:'inline-block',verticalAlign:'bottom'}} className={'key_btn'} onClick={()=>{setModal('');action(null)}}><div style={{height:'30px',lineHeight:'30px',display:'block'}}>{localestr('Закрити')}</div></div>
            </div></div>
        </div></div>
    )
}

export default LongTextForm